import { Link, Typography } from "@mui/material";
import { useStardustTermsUrl } from "Components/Loyalty/Stardust/useStardustTermsUrl";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Onboarding.Steps.PersonalInformation.StardustParticipation;

/**
 * Label of the Stardust consent checkbox in the registration wizard (ZS-1624). Links the program
 * terms PDF.
 */
export const StardustParticipationCheckboxLabel = () => {
  const { t } = useResource();
  const termsUrl = useStardustTermsUrl();

  return (
    <Typography>
      {t(COMPONENT_RESOURCES.Text)}
      <Link target="_blank" rel="noopener noreferrer" href={termsUrl} mx={1}>
        {t(COMPONENT_RESOURCES.LinkText)}
      </Link>
    </Typography>
  );
};
